<div class="tile" [class.active]="status==='hoverOn'">
  <a class="stagger-elem nav-link p-0" (click)="onDelete()">
    <span><i class="icon icon-trash" aria-hidden="true"></i></span>
  </a>
</div>